/* angular:styles/component:css;e2dfe814b973c158;/home/runner/work/app/app/src/app/components/desktop-update-pill/desktop-update-pill.component.ts */
.crwd-app-update__pill {
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translate(-50%);
  z-index: 300;
  display: flex;
  align-items: center;
  gap: .75rem;
  max-width: calc(100vw - 2rem);
  padding: .5rem .5rem .5rem 1rem;
  border: 1px solid var(--border-color, #e2e8f0);
  border-radius: var(--radius-xl, .75rem);
  background: var(--surface-color, #fff);
  color: var(--text-color, #18191a);
  font-family: var(--font-body, "Inter", system-ui, sans-serif);
  box-shadow: var(--shadow-lg, 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1));
}
.crwd-app-update__label {
  min-width: 0;
  font-size: .75rem;
  line-height: 1rem;
}
.crwd-app-update__action {
  flex: none;
  padding: .25rem .75rem;
  border: none;
  border-radius: 9999px;
  background: var(--color-primary-600, #4c17ca);
  color: #fff;
  font-family: inherit;
  font-size: .75rem;
  font-weight: 500;
  line-height: 1rem;
  cursor: pointer;
  transition: background-color .15s ease;
}
.crwd-app-update__action:hover {
  background: var(--color-primary-700, #3d12a2);
}
.crwd-app-update__action:disabled {
  opacity: .6;
  cursor: default;
}
.crwd-app-update__action:focus-visible,
.crwd-app-update__dismiss:focus-visible {
  outline: 2px solid var(--color-primary-500, #6221e0);
  outline-offset: 2px;
}
.crwd-app-update__dismiss {
  flex: none;
  width: 1.5rem;
  height: 1.5rem;
  border: none;
  border-radius: 9999px;
  background: transparent;
  color: inherit;
  opacity: .6;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}
.crwd-app-update__dismiss:hover {
  opacity: 1;
  background: var(--hover-color, rgb(0 0 0 / .06));
}
/*# sourceMappingURL=desktop-update-pill.component-UIWD3FA4.css.map */
